import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';
import { percentage } from '@camelot/utils';

import { ItemType } from '../../../../../common/services/dto/item-type';
import { BillingRow } from '../../../../../common/services/dto/row';

@Component({
  host: { 'data-cid': 'grid-billing-quantity-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  template: `{{ this.quantityName }}`,
})
export class GridBillingQuantityCellComponent extends AbstractCellComponent<BillingRow, number> {
  get quantityName() {
    if (this._item?.itemType === ItemType.Reduction) {
      return `${percentage(this.value ?? 0, 1)}%`;
    }
    return this.value ? this.value : '';
  }
}
